export enum ACTIONS {
  ALLOW = "allow",
  DENY = "deny",
}

// We have Acl subjects for Appointment Custom Variables as well
// Check OptionsSelectDropdown component
export enum SUBJECT_KEYS {
  START_VISIT = "START_VISIT",
  PATIENT_REGISTRATION = "PATIENT_REGISTRATION",
  PATIENT_DATABASE = "PATIENT_DATABASE",
  QUEUE = "QUEUE",
  RX = "RX",
  GENIE = "GENIE",
  PAYMENT_ID_IN_RECEIPT = "PAYMENT_ID_IN_RECEIPT",
  SKU_EDIT = "SKU_EDIT",
  SKU_CREATE = "SKU_CREATE",
  CAN_CREATE_RECEIPT_WITH_APT = "CAN_CREATE_RECEIPT_WITH_APT",
  CAN_REQUEST_RECORDS = "CAN_REQUEST_RECORDS",
  ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS",
  SETTINGS_AND_PREFERENCES = "SETTINGS_AND_PREFERENCES",
  AVAILABILITY = "AVAILABILITY",
  SERVICES = "SERVICES",
  PACKAGES = "PACKAGES",
  CALENDAR_MANAGEMENT = "CALENDAR_MANAGEMENT",
  APPOINTMENT_MANAGEMENT = "APPOINTMENT_MANAGEMENT",
  PROFILE_MANAGEMENT = "PROFILE_MANAGEMENT",
  ANALYTICS = "ANALYTICS",
  PAYOUT_REPORTS = "PAYOUT_REPORTS",
  VITALS_COLLECTION = "VITALS_COLLECTION",
  MEDICAL_RECORD_UPLOAD = "MEDICAL_RECORD_UPLOAD",
  MEDICAL_HISTORY_CAPTURE = "MEDICAL_HISTORY_CAPTURE",
  RECEIPT_CREATION = "RECEIPT_CREATION",
  RECEIPT_EDIT = "RECEIPT_EDIT",
  DHIS_ENABLEMENT = "DHIS_ENABLEMENT",
  DHIS_INCENTIVE = "DHIS_INCENTIVE",
  DAILY_FINANCE_OVERVIEW_STRIP = "DAILY_FINANCE_OVERVIEW_STRIP",
  DOWNLOAD_QUEUE = "DOWNLOAD_QUEUE",
  LEFT_BLOCK_ON_NEW_QUEUE = "LEFT_BLOCK_ON_NEW_QUEUE",
  GO_TO_OLD_QUEUE = "GO_TO_OLD_QUEUE",
  PATIENT_MOBILE_NUMBER = "PATIENT_MOBILE_NUMBER",
  DELETE_RECEIPT = "DELETE_RECEIPT",
  ADD_PATIENT_ADDRESS = "ADD_PATIENT_ADDRESS",
  UPLOAD_MEDICAL_RECORDS = "UPLOAD_MEDICAL_RECORDS",
  ABHA = "ABHA",
  SA = "SA",
  TREATMENT = "TREATMENT",
  REFER_PATIENT_TO_DOCTOR = "REFER_PATIENT_TO_DOCTOR",
  SEND_GOOGLE_REVIEW = "SEND_GOOGLE_REVIEW",
  SEND_RX = "SEND_RX",
  CREATE_CUSTOM_QUEUE = "CREATE_CUSTOM_QUEUE",
  CREATE_MEDICAL_DOCUMENTS = "CREATE_MEDICAL_DOCUMENTS",
  EDIT_QUEUE = "EDIT_QUEUE",
  APPOINTMENTS_CALENDAR_VIEW = "APPOINTMENTS_CALENDAR_VIEW",
  DELETE_APPOINTMENT = "DELETE_APPOINTMENT",
  GLOBAL_SEARCH = "GLOBAL_SEARCH",
  ADD_VACCINATION = "ADD_VACCINATION",
  CHECKIN_APPT = "CHECKIN_APPT",
  CANCEL_APPT = "CANCEL_APPT",
  SEND_REMINDER = "SEND_REMINDER",
  MARK_NO_SHOW = "MARK_NO_SHOW",
  UPDATE_NOTES = "UPDATE_NOTES",
  ARCHIVE_PATIENTS = "ARCHIVE_PATIENTS",
  EXIT_APPT = "EXIT_APPT",
  SWITCH_WORKSPACE = "SWITCH_WORKSPACE",
  PAD_ACCESS = "PAD_ACCESS",
  PARK_APT = "PARK_APT",
  GROUP_SELECTOR = "GROUP_SELECTOR",
  PRINT_OPD_SLIP_BTN = 'PRINT_OPD_SLIP_BTN',
  PAY_DASH_BEYOND_TODAY = "PAY_DASH_BEYOND_TODAY",
  SHOW_SLOTS_OF_SEO_PAGE = "SHOW_SLOTS_OF_SEO_PAGE",
  EKA_AI_ASSESSMENTS = "EKA_AI_ASSESSMENTS",
  PT_DETAILS_VISIT_ACTIONS = "PT_DETAILS_VISIT_ACTIONS"
}

export enum GROUP {
  PATIENT_MANAGEMENT = "Patient Management",
  DOCTOR_AVAILABILITY = "Doctor Availability",
  BILLING_AND_SERVICES = "Billing and Services",
  PACKAGES = "Packages",
  ADMINISTRATION_AND_REPORTING = "Administration and Reporting",
  OTHERS = "Others",
}
